import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentStep: 1,
  email: '',
  otp: '',
  newPassword: '',
  confirmNewPassword: '',
};

const IntroductionSlice = createSlice({
  name: 'introduction',
  initialState,
  reducers: {
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setOtp: (state, action) => {
      state.otp = action.payload;
    },
    setNewPassword: (state, action) => {
      state.newPassword = action.payload;
    },
    setConfirmNewPassword: (state, action) => {
      state.confirmNewPassword = action.payload;
    },
    resetIntroductionFlow: () => initialState,
  },
});

export const {
  setCurrentStep,
  setEmail,
  setOtp,
  setNewPassword,
  setConfirmNewPassword,
  resetIntroductionFlow,
} = IntroductionSlice.actions;
export default IntroductionSlice.reducer;
